<template>
  <div>
    <div class="col-md-13 mt-md-3 text-right">
      <div @click="showModal" class="my-account link">
        <font-awesome-icon class="font-awesome-icon" icon="sign-out-alt"/>
        Uitloggen
      </div>
    </div>

    <b-modal
      ref="confirm-logout-modal"
      id="confirm-logout-modal"
      footer-class="modal-footer"
      size="sm"
      centered
    >
      <template slot="modal-header">
        <h4 class="modal-title">Let op!</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          Weet je zeker dat je wilt uitloggen?
        </div>
      </template>

      <template slot="modal-footer">
        <button
          @click="hideModal"
          type="button"
          class="btn btn-round">Annuleren
        </button>
        <button
          @click="logout"
          type="button"
          class="btn btn-oldevuuren btn-round">Uitloggen
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { LOGOUT } from '../../store/types'

  export default {
    methods: {
      logout() {
        this.$store.dispatch(LOGOUT)
      },
      showModal() {
        this.$refs['confirm-logout-modal'].show()
      },
      hideModal() {
        this.$refs['confirm-logout-modal'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
